import type { $Fetch } from "ofetch";
import type {
  TokenValidationHttpResult,
  TokenValidationMethod,
} from "../../util/tokenAuthDiagnostic";
import { sanitizeDiagnosticUrl } from "../../util/tokenAuthDiagnostic";
// @ts-ignore
// import { ClientJS } from "clientjs/dist/client.min.js";

/**
 * Nome do Controller da API
 */
const controller = "/Acesso";

/**
 * Classe de gerenciamento de chamadas da API de relatórios
 *
 * @class
 */
export default class AcessoApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe ReportApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(
    api: $Fetch,
    private readonly baseUrl: string,
  ) {
    this.api = api;
  }

  /**
   * @param identificacao - Nome do usuário
   * @param senha - Senha do usuário
   * @returns objeto contendo as informações do usuário
   */
  login(identificacao: string, senha: string) {
    return this.api<any>(`${controller}/login`, {
      method: "POST",
      body: {
        identificacao: identificacao,
        senha: senha,
      },
    });
  }

  loginWbAgendamento(identificacao: string, senha: string) {
    return this.api<any>(`${controller}/login`, {
      method: "POST",
      body: {
        identificacao: identificacao,
        senha: senha,
      },
      credentials: "include",
    });
  }

  /**
   * @param pin - Senha do usuário
   * @returns objeto contendo as informações do usuário
   */
  pinPad(pin: string) {
    return this.api<any>(`${controller}/loginPin`, {
      method: "POST",
      params: { pin },
    });
  }

  logout() {
    return this.api<any>(`${controller}/efetuarlogoff`, {
      method: "POST",
    });
  }
  refreshToken(username: string, password: string, oldToken: string) {
    return this.api<any>(`${controller}/refreshToken`, {
      method: "POST",
      params: {
        Identificacao: username,
        Senha: password,
        OldToken: oldToken,
      },
    });
  }

  async validarToken(
    method: TokenValidationMethod = "GET",
  ): Promise<TokenValidationHttpResult> {
    const endpoint = `${controller}/validarToken`;
    const normalizedBaseUrl = this.baseUrl.replace(/\/+$/, "");
    const requestedUrl = `${normalizedBaseUrl}${endpoint}`;
    const startedAt = Date.now();

    try {
      const response = await this.api.raw<string>(endpoint, {
        method,
        retry: 0,
        ignoreResponseError: true,
        responseType: "text" as any,
      });
      const finishedAt = Date.now();

      return {
        baseUrl: sanitizeDiagnosticUrl(normalizedBaseUrl),
        endpoint,
        requestedUrl: sanitizeDiagnosticUrl(response.url || requestedUrl),
        method,
        status: response.status,
        startedAt,
        finishedAt,
        durationMs: finishedAt - startedAt,
        serverDate: response.headers.get("date"),
        wwwAuthenticate: response.headers.get("www-authenticate"),
        networkError: null,
      };
    } catch {
      const finishedAt = Date.now();

      return {
        baseUrl: sanitizeDiagnosticUrl(normalizedBaseUrl),
        endpoint,
        requestedUrl: sanitizeDiagnosticUrl(requestedUrl),
        method,
        status: null,
        startedAt,
        finishedAt,
        durationMs: finishedAt - startedAt,
        serverDate: null,
        wwwAuthenticate: null,
        networkError: "O navegador não conseguiu alcançar o endpoint.",
      };
    }
  }
}
